import * as jsxRuntime from "/codebuild/output/src3136051215/src/lantern/firefly_static/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment